/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Start_Page_Chat_BookedInputs */

const en_start_page_chat_booked = /** @type {(inputs: Start_Page_Chat_BookedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Booked Thursday 18:30, thanks!`)
};

const pl_start_page_chat_booked = /** @type {(inputs: Start_Page_Chat_BookedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarezerwowałam czwartek 18:30, dzięki!`)
};

/**
* | output |
* | --- |
* | "Booked Thursday 18:30, thanks!" |
*
* @param {Start_Page_Chat_BookedInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const start_page_chat_booked = /** @type {((inputs?: Start_Page_Chat_BookedInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Start_Page_Chat_BookedInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_start_page_chat_booked(inputs)
	return en_start_page_chat_booked(inputs)
});